import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const failedSendCreditTasksListColumns = [
  'failedSendCreditTasks.id',
  'failedSendCreditTasks.attempts',
  'failedSendCreditTasks.finishedOn',
  'failedSendCreditTasks.processedOn',
  'failedSendCreditTasks.failedReason',
  'failedSendCreditTasks.data.transactionId',
  'failedSendCreditTasks.data.roundId',
  'failedSendCreditTasks.data.providerId',
  'failedSendCreditTasks.data.playerId',
  'failedSendCreditTasks.data.betId',
] as const;

export type FailedSendCreditTasksListColumns = (typeof failedSendCreditTasksListColumns)[number];

export type FailedSendCreditTasksListFilter = {
  'failedSendCreditTasks.id': string | undefined;
  'failedSendCreditTasks.attempts': string | undefined;
  'failedSendCreditTasks.finishedOn': string | undefined;
  'failedSendCreditTasks.processedOn': string | undefined;
  'failedSendCreditTasks.failedReason': string | undefined;
  'failedSendCreditTasks.data.transactionId': string | undefined;
  'failedSendCreditTasks.data.roundId': string | undefined;
  'failedSendCreditTasks.data.providerId': string | undefined;
  'failedSendCreditTasks.data.playerId': string | undefined;
  'failedSendCreditTasks.data.betId': string | undefined;
};

export const defaultFailedSendCreditTasksListFilter: FailedSendCreditTasksListFilter = {
  'failedSendCreditTasks.id': undefined,
  'failedSendCreditTasks.attempts': undefined,
  'failedSendCreditTasks.finishedOn': undefined,
  'failedSendCreditTasks.processedOn': undefined,
  'failedSendCreditTasks.failedReason': undefined,
  'failedSendCreditTasks.data.transactionId': undefined,
  'failedSendCreditTasks.data.roundId': undefined,
  'failedSendCreditTasks.data.providerId': undefined,
  'failedSendCreditTasks.data.playerId': undefined,
  'failedSendCreditTasks.data.betId': undefined,
};

export const failedSendCreditTasksListColumnVisibilitySettings = {
  'failedSendCreditTasks.id': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.attempts': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.finishedOn': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.processedOn': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.failedReason': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.data.transactionId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.data.roundId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.data.providerId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.data.playerId': ColumnVisibilityType.CanBeHidden,
  'failedSendCreditTasks.data.betId': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<FailedSendCreditTasksListColumns>;

export const defaultFailedSendCreditTasksListColumnVisibility = defaultColumnVisibilityParams(
  failedSendCreditTasksListColumnVisibilitySettings
);

export const failedSendCreditTasksListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  failedSendCreditTasksListColumns,
  failedSendCreditTasksListColumnVisibilitySettings
);
